/// <amd-module name="Build/Common/Library/Components/CommandComponent" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import {
    WrappedComponent
} from "VSS/Platform/Layout";

export interface ICommandComponentProps {
    commandType: string;
    [propertyName: string]: any;
}

const c_commandDependencies = [
    "ms.vss-distributedtask-web.common-library",
    "ms.vss-build-web.common-commands"
];

export class CommandComponent extends React.Component<ICommandComponentProps, {}> {
    public render() {
        return <WrappedComponent
            dependencies={c_commandDependencies}
            wrappedType={this.props.commandType}
            {...this.props}
        />;
    }
}

export function prefetch(pageContext: IVssPageContext) {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    contributionService.getContributionAsync("ms.vss-build-web.queue-panel");
    contributionService.getContributionAsync("ms.vss-build-web.common-commands");
    contributionService.getContributionAsync("ms.vss-build-web.common-library-legacy");
    contributionService.getContributionAsync("ms.vss-distributedtask-web.common-library");
}
